// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"9c1653e5","952":"939cc1e9"}[chunkId] + ".chunk.js";
};